module.exports = __webpack_public_path__ + "img/julio_palette.aa1633e6.png";